import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GetYoutubeMCNRedirectUrlForAdmin.graphql';
import { Query, QuerygetYoutubeMCNRedirectUrlForAdminArgs } from '../../__generated__/globalTypes';

export const useGetYoutubeMCNRedirectUrlForAdminQuery = (
  options?: QueryHookOptions<Query, QuerygetYoutubeMCNRedirectUrlForAdminArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygetYoutubeMCNRedirectUrlForAdminArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGetYoutubeMCNRedirectUrlForAdminLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygetYoutubeMCNRedirectUrlForAdminArgs>
): QueryResult<Query, QuerygetYoutubeMCNRedirectUrlForAdminArgs> & {
  getGetYoutubeMCNRedirectUrlForAdmin: LazyQueryExecFunction<Query, QuerygetYoutubeMCNRedirectUrlForAdminArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGetYoutubeMCNRedirectUrlForAdmin, result] = useLazyQuery<Query, QuerygetYoutubeMCNRedirectUrlForAdminArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getGetYoutubeMCNRedirectUrlForAdmin, ...result };
};

export const useGetYoutubeMCNRedirectUrlForAdminPromiseQuery = () => {
  const client = useApolloClient();

  const getGetYoutubeMCNRedirectUrlForAdmin = useCallback(
    (options?: Omit<QueryOptions<QuerygetYoutubeMCNRedirectUrlForAdminArgs, Query>, 'query'>) =>
      client.query<Query, QuerygetYoutubeMCNRedirectUrlForAdminArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGetYoutubeMCNRedirectUrlForAdmin };
};
// Suspense Query Hooks
export const useGetYoutubeMCNRedirectUrlForAdminSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerygetYoutubeMCNRedirectUrlForAdminArgs>
) => {
  const result = useSuspenseQuery<Query, QuerygetYoutubeMCNRedirectUrlForAdminArgs>(QUERY, {
    ...options
  });

  return result;
};
